/* Safe Minimal main.js Replacement
   The original file was removed due to unsafe external script loading.
   This version provides basic theme helpers without any network behavior.
*/

document.addEventListener('DOMContentLoaded', function () {
    console.log('Sanitized main.js loaded - external/obfuscated code removed for safety.');
  
    // Create safe namespace
    window.theme = window.theme || {};
  
    /* -------------------------------
        Helper: Toggle class
    --------------------------------*/
    theme.toggleClass = function (el, cls) {
      if (!el) return;
      if (el.classList) {
        el.classList.toggle(cls);
      } else {
        // fallback for older browsers
        var classes = el.className.split(/\s+/);
        var idx = classes.indexOf(cls);
        if (idx >= 0) classes.splice(idx, 1);
        else classes.push(cls);
        el.className = classes.join(' ');
      }
    };
  
    /* -------------------------------
        Helper: Safe querySelector
    --------------------------------*/
    theme.q = function (sel, ctx) {
      try {
        return (ctx || document).querySelector(sel);
      } catch (e) {
        return null;
      }
    };
  
    /* -------------------------------
        Helper: Safe event listener
    --------------------------------*/
    theme.on = function (el, ev, fn) {
      if (!el) return;
      try {
        el.addEventListener(ev, fn);
      } catch (e) {}
    };
  
    /* -------------------------------
        Accessible mobile menu toggle
    --------------------------------*/
    (function () {
      var btn = theme.q('[data-menu-toggle]');
      var nav = theme.q('[data-menu]');
  
      if (!btn || !nav) return;
  
      theme.on(btn, 'click', function (e) {
        e.preventDefault();
        theme.toggleClass(nav, 'is-open');
        theme.toggleClass(btn, 'is-open');
      });
    })();
  
    // Add any additional safe, local-only behaviors here.
  });
  